import i18n from '@/i18n';
import { storeToRefs } from 'pinia';
import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router';
import { useUserInfoStore } from '../collections/user-info/user-info.store';

const AUTH_GUARD = async (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
   /* Checking if the user is trying to access the error page and if the error page has the correct query params. */
   checkErrorPage(to, next);

   /* Fetching the user information from the backend. */
   await fetchUserInfo();

   /* Check if user info fetch failed with 403 or user is empty */
   const userInfoStore = useUserInfoStore();
   const { userInfo, authError } = storeToRefs(userInfoStore);

   if (authError.value === 403 || !userInfo.value) {
      return next({
         path: '/error',
         query: {
            error_code: '403',
            error_title: i18n.global.t('generic.access-denied'),
            error_message: i18n.global.t('generic.u-have-no-access'),
            error_action: 'home-or-logout',
         },
      });
   }

   /* Checking if the user has the permission to access the route. */
   checkIfUserHasPermission(to, next);
};

function trimKeycloakQueryParams(to: RouteLocationNormalized, next: NavigationGuardNext) {
   const keycloakQueryParams = ['code', 'session_state', 'state'];

   const hasKeycloakParams =
      Object.keys(to.query).filter((param) => keycloakQueryParams.find((keycloakParam) => keycloakParam === param)).length > 0;

   if (hasKeycloakParams) {
      const query = Object.entries(to.query)
         .filter(([key, _]) => !keycloakQueryParams.find((keycloakParam) => keycloakParam === key))
         .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
      return next({ ...to, query });
   }
}

function checkErrorPage(to: RouteLocationNormalized, next: NavigationGuardNext) {
   const userInfoStore = useUserInfoStore();
   const { loadingUserInfo } = storeToRefs(userInfoStore);

   const isErrorPage = to.name === 'ErrorPage';
   const hasErrorParams = to.query.error_code && to.query.error_title;

   if (isErrorPage) {
      if (!hasErrorParams) return next('/');
      //user will not be fetched so loading can be disabled
      loadingUserInfo.value = false;
      return next();
   }
}

function checkIfUserHasPermission(to: RouteLocationNormalized, next: NavigationGuardNext) {
   const requiresPermission = !!to.meta.permission;
   if (!requiresPermission) return next();

   const requiredScopes = (to.meta.scopes as Array<string>) || ['view'];
   // const permission = permissions?.[to.meta.permission as string];
   // const hasRequiredPermission = checkAccess(requiredScopes, permission);

   // if (hasRequiredPermission)
   return next();

   return next({
      path: '/error',
      query: {
         error_code: '403',
         error_title: i18n.global.t('generic.access-denied'),
         error_message: i18n.global.t('generic.u-have-no-access'),
         error_action: 'home-or-logout',
      },
   });
}

async function fetchUserInfo() {
   const userInfoStore = useUserInfoStore();
   const { userInfo, loadingUserInfo } = storeToRefs(userInfoStore);

   if (!loadingUserInfo.value) return;
   if (!userInfo.value) {
      await userInfoStore.getUserInfo();
   }
}

export default AUTH_GUARD;
